import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';

import { dispatchResizeEvent } from 'helpers/window';
import RichEditorContent from 'components/RichEditorContent';
import AbstractCmsElement from './AbstractCmsElementNew';

class CmsElementHero extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };

    this.containerRef = React.createRef();
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  componentDidMount = () => {
    const backgroundUrl = this.getParamValue('backgroundUrl');
    if (backgroundUrl) {
      const img = new Image();
      img.onload = () => {
        dispatchResizeEvent();
      };
      img.src = backgroundUrl;
    }

    this.__componentDidMount();
  };

  componentWillUnmount = () => {
    // ALTEN Scroll-Listener entfernt!
    this.__componentWillUnmount();
  };

  render() {
    const { shown } = this.state;
    const { editMode, layout } = this.props;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const content = this.getParamValue('content', '');
    const headerStyle = {
      height: this.getParamValue('fullHeight', 'no') === 'yes' ? layout.height + 'px' : 'auto',
    };

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={
          'ms-hero jumbotron bg-transparent full-height no-padding ' +
          shownClass +
          this.getResponsiveClasses() +
          this.getCssClasses()
        }
        ref={this.containerRef}
      >
        {this.getElementStyle()}

        <Parallax opacity={[1, 0]} speed={-3} disabled={editMode} className="full-height">
          <div
            className="container-fluid container-fixed-lg sm-p-l-20 sm-p-r-20"
            style={{
              ...headerStyle,
              ...this.getBackgroundStyle(),
            }}
          >
            <div className="content inner full-height">
              <div className="container-xs-height full-height">
                <div className={'col-xs-height ' + (this.getParamValue('vAlignMiddle', false) ? 'col-middle ' : '')}>
                  <Container fluid={this.getParamValue('isFluid', 'no') === 'yes'}>
                    <Row>
                      <Col xs={12} className={'text-' + this.getParamValue('mainColor', 'master')}>
                        <RichEditorContent content={'<div>' + content + '</div>'} />
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </Parallax>

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>
    );
  }
}

CmsElementHero.defaultProps = {
  index: '0',
};

const mapStateToProps = state => {
  return {
    layout: state.layout,
  };
};

export default connect(mapStateToProps)(CmsElementHero);
